var map = {
	"./_demo/store": [
		"982a",
		"chunk-5eb3c019"
	],
	"./announcements/store": [
		"3952",
		"chunk-9b1e4ec2"
	],
	"./collab/store": [
		"c879",
		"chunk-708ffbe8"
	],
	"./events/store": [
		"d501",
		"chunk-06377fa9"
	],
	"./forms/store": [
		"2925",
		"chunk-452245fd"
	],
	"./interests/store": [
		"dac4",
		"chunk-5c008fcc"
	],
	"./links/store": [
		"f22e",
		"chunk-1d7be7be"
	],
	"./news/store": [
		"18c1",
		"chunk-bacd227e"
	],
	"./policies/store": [
		"c043",
		"chunk-cc652730"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6a9e";
module.exports = webpackAsyncContext;